import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M2.5 12.5V4.5C2.5 3.94772 2.94772 3.5 3.5 3.5H9.96482C10.2992 3.5 10.6114 3.6671 10.7969 3.9453L12.2031 6.0547C12.3886 6.3329 12.7008 6.5 13.0352 6.5H19.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="1.5"
        />
        <path
            d="M17.7362 20.5H4.30925C3.64988 20.5 3.17099 19.873 3.34449 19.2369L5.79903 10.2369C5.91769 9.80182 6.31284 9.5 6.7638 9.5H20.1908C20.8501 9.5 21.329 10.127 21.1555 10.7631L18.701 19.7631C18.5823 20.1982 18.1872 20.5 17.7362 20.5Z"
            stroke="currentColor"
            strokeWidth="1.5"
        />
    </svg>
);

export default Icon;
